import { render, staticRenderFns } from "./AdminDetailView.vue?vue&type=template&id=77ed1a6e&scoped=true"
import script from "./AdminDetailView.vue?vue&type=script&lang=js"
export * from "./AdminDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ed1a6e",
  null
  
)

export default component.exports